"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _Slide = _interopRequireDefault(require("@material-ui/core/Slide"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Transition = /*#__PURE__*/_react.default.forwardRef(function Transition(props, ref) {
  return /*#__PURE__*/_react.default.createElement(_Slide.default, _extends({
    direction: "up",
    ref: ref
  }, props));
});

var NicaDialog = function NicaDialog(_ref) {
  var open = _ref.open,
      title = _ref.title,
      onClose = _ref.onClose,
      maxWidth = _ref.maxWidth,
      children = _ref.children,
      actions = _ref.actions;
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: open,
    onClose: onClose,
    TransitionComponent: Transition,
    maxWidth: maxWidth
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    disableTypography: true
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "dialog-title"
  }, title)), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, children), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, actions));
};

NicaDialog.defaultProps = {
  maxWidth: "sm"
};
var _default = NicaDialog;
exports.default = _default;